import { render, staticRenderFns } from "./StepFiles.vue?vue&type=template&id=38b146ea&"
import script from "./StepFiles.vue?vue&type=script&lang=js&"
export * from "./StepFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38b146ea')) {
      api.createRecord('38b146ea', component.options)
    } else {
      api.reload('38b146ea', component.options)
    }
    module.hot.accept("./StepFiles.vue?vue&type=template&id=38b146ea&", function () {
      api.rerender('38b146ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/sharedSteps/StepFiles.vue"
export default component.exports